import React from "react"
import SVG from "react-inlinesvg"
import { toAbsoluteUrl } from "../../../../_metronic/_helpers"
import { ICON_CONSTANTS } from "../../../../constants/ImageConstants.js"

export const ApproveSvgIcon = () => {
  return (
    <span className="svg-icon svg-icon-md svg-icon-success">
      <SVG src={toAbsoluteUrl(ICON_CONSTANTS.APPROVAL)} />
    </span>
  )
}
